import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { c as a } from "./clsx-OuTLNxxd.js";
import { T as r } from "./text-CkxBSewo.js";
const o = "_element_245v3_29", t = {
  element: o,
  "element-title": "_element-title_245v3_37"
}, d = ({ className: l, elements: n }) => {
  const m = a(t.container, l);
  return /* @__PURE__ */ e("ol", { className: m, children: n.map((s, c) => /* @__PURE__ */ i("li", { className: t.element, children: [
    /* @__PURE__ */ e("span", { className: t["element-title"], children: s.title }),
    /* @__PURE__ */ e(r, { children: s.text })
  ] }, `list-element-${c}`)) });
};
export {
  d as L,
  o as e
};
